<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Excluir estoque</h2>
    <span class="modal-subtitle">OP {{ data.numero }} · {{ data.nomeProduto }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isCarregando) {
  <div class="carregando">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  } @else {

  <p class="texto-ajuda">
    As movimentações de estoque desta ordem serão excluídas: a matéria-prima consumida volta ao estoque
    e o produto fabricado que entrou sai.
  </p>

  @if (entrada) {
  <div class="linha-movimento linha-movimento--saida">
    <mat-icon class="material-symbols-outlined">arrow_upward</mat-icon>
    <div>
      <strong>{{ entrada.nomeProduto }}</strong>
      <span class="linha-movimento__detalhe">
        −{{ entrada.quantidade | abnt:'quantidade' }} {{ entrada.unidade }} de "{{ entrada.descricaoLocalizacao }}"
      </span>
    </div>
  </div>
  }

  @for (insumo of insumos; track insumo.idProduto) {
  <div class="linha-movimento linha-movimento--entrada">
    <mat-icon class="material-symbols-outlined">arrow_downward</mat-icon>
    <div>
      <strong>{{ insumo.nomeProduto }}</strong>
      <span class="linha-movimento__detalhe">
        +{{ insumo.quantidade | abnt:'quantidade' }} {{ insumo.unidade }} de volta em "{{ insumo.descricaoLocalizacao }}"
      </span>
    </div>
  </div>
  }

  <mat-form-field appearance="outline" class="w-100 mt-3">
    <mat-label>Justificativa</mat-label>
    <textarea matInput rows="4" maxlength="500" [formControl]="justificativa"
      placeholder="Informe o motivo da exclusão"></textarea>
    <mat-hint align="end">{{ justificativa.value.length }}/500</mat-hint>
    @if (justificativa.hasError('required') || justificativa.hasError('minlength')) {
    <mat-error>Informe ao menos 10 caracteres.</mat-error>
    }
  </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary" [disabled]="isCarregando" (click)="confirmar()">Confirmar exclusão</button>
</mat-dialog-actions>
